import {SoundData} from "./types";
import {Howl} from "howler";


const countdownLatch = (total: number, doneFn?: () => void,) => {
    let counter = 0;
    return function () {
        counter++
        if (counter == total) {
            console.log("done")
            if (doneFn) doneFn()
        }
    }
}

export function init(doneFn?: () => void): { [p: string]: Howl } {
    console.log("initialing audio-map");
    const loadData = (): SoundData => {
        const elementById = document.getElementById('sounds');
        if (elementById == null) {
            console.error('Cannot find <script id="sounds" type="application/json">')
            return {}
        } else
            return JSON.parse(elementById.innerHTML);
    }


    const data: SoundData = loadData()
    const dataKeys = Object.keys(data);
    const count = dataKeys.length
    Howler.html5PoolSize = count;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isWebAudio = Howler.usingWebAudio && (typeof AudioContext !== 'undefined' || typeof (window as any).webkitAudioContext !== 'undefined');
    if (!isWebAudio) {
        console.warn("Howler fallback to HTML5 Audio");
        // @ts-expect-error _html5AudioPool is unknown
        if (Howler._html5AudioPool) {
            try {
                // @ts-expect-error _html5AudioPool is unknown
                while (Howler._html5AudioPool.length < count) {
                    // @ts-expect-error _html5AudioPool is unknown
                    Howler._html5AudioPool.push(new Audio());
                }
            } catch (error) {
                console.warn("Howler error while expanding the pool", error);
            }
        } else {
            console.warn("Howler does not have a property _html5AudioPool");
        }

    } else {
        console.warn("Howler using WebAudio");
    }
    const latch = countdownLatch(count, doneFn)
    return dataKeys.reduce((acc, id) => {
        const howl = new Howl({
            src: data[id].src,
            loop: Boolean(data[id].loop),
            onplayerror: function () {
                console.log("error");
                howl.once('unlock', function () {
                    howl.play();
                });
            },
            onload: latch,
            onloaderror: latch
        });


        howl.on("fade", (n) => {
            if (howl.volume() === 0) {
                console.log("stopping");
                howl.stop(n);
            }
        });
        return Object.assign(acc, {
            [id]: howl
        });
    }, {})

}
